export const ArrowUpIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 7.625l4.5-4.5 4.5 4.5M8 3.75v9.125"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
